import { OrganizationDetailFragment, useUpdateStripeCompanyAccount } from '@alice-financial/alice-sdk'
import { useForm, SubmitHandler } from 'react-hook-form'

export interface FinancialInformationFormValues {
  annualRevenue: string // stored as cents
  fiscalYearEnd: string // YYYY-MM-DD format
}

export const useFinancialInformationForm = (org: OrganizationDetailFragment) => {
  const { mutate: updateStripeCompanyAccount, isLoading } = useUpdateStripeCompanyAccount()

  const defaultValues: FinancialInformationFormValues = {
    annualRevenue: '',
    fiscalYearEnd: `${new Date().getFullYear() - 1}-12-31`,
  }

  const form = useForm<FinancialInformationFormValues>({
    defaultValues,
    mode: 'onChange',
  })

  const { watch } = form
  const watchedValues = watch()

  // Check if all required fields are filled
  const isFormValid = Boolean(watchedValues.annualRevenue && watchedValues.fiscalYearEnd)

  const onSubmit: SubmitHandler<FinancialInformationFormValues> = async (values) => {
    // Only submit if at least one field has a value
    const hasData = values.annualRevenue || values.fiscalYearEnd
    if (hasData) {
      // the annualRevenue value is an integer representing cents - convert to whole dollars
      const annualRevenue = values.annualRevenue
        ? Math.floor(parseInt(values.annualRevenue) / 100)
        : undefined
      updateStripeCompanyAccount({
        input: {
          orgId: org.id,
          annualRevenue,
          fiscalYearEnd: values.fiscalYearEnd || undefined,
        },
      })
    }
  }

  return {
    ...form,
    onSubmit: form.handleSubmit(onSubmit),
    isLoading,
    isFormValid,
    resetForm: () => form.reset(defaultValues),
  }
}
